import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../api/axiosInstance";

import iconImg from "../../assets/image/swc.png";
import RANKS from "../../utils/ranks";

const Register = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    member_rank: "ไม่ระบุ",
    member_name: "",
    member_surname: "",
    member_position: "",
    user_name: "",
    password: "",
    confirm_password: "",
  });

  // Form field change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Form validation
  const validateForm = () => {
    const {
      member_name,
      member_surname,
      member_position,
      user_name,
      password,
      confirm_password,
    } = formData;
    const newErrors = {};

    if (!member_name) newErrors.member_name = "กรุณากรอกชื่อ";
    if (!member_surname) newErrors.member_surname = "กรุณากรอกสกุล";
    if (!member_position) newErrors.member_position = "กรุณากรอกตำแหน่ง";
    if (!user_name) {
      newErrors.user_name = "กรุณากรอก Username";
    } else if (/[\u0E00-\u0E7F]/.test(user_name)) {
      newErrors.user_name = "ห้ามมีตัวอักษรภาษาไทย";
    } else if (/[A-Z]/.test(user_name)) {
      newErrors.user_name = "ต้องเป็นตัวพิมพ์เล็กเท่านั้น";
    }

    if (!password) newErrors.password = "กรุณากรอก Password";
    if (!confirm_password) {
      newErrors.confirm_password = "กรุณากรอก Confirm Password";
    } else if (password !== confirm_password) {
      newErrors.confirm_password = "Password และ Confirm Password ต้องตรงกัน";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit handler
  const handleSubmit = async () => {
    if (!validateForm()) return;

    const payload = {
      member_rank: formData.member_rank,
      member_name: formData.member_name,
      member_surname: formData.member_surname,
      member_position: formData.member_position,
      user_name: formData.user_name,
      password: formData.password,
    };

    try {
      const response = await api.post("/api/member/addmember", payload);


      // Check server response
      if (response.status === 200 || response.status === 201) {
        const { message } = response.data; // depends on server response structure
        toast.success(message || "สมัครสมาชิกสำเร็จ");

        // Redirect after a short delay
        setTimeout(() => navigate("/"), 3000);
      } else {
        toast.error(response.data?.message || "เกิดข้อผิดพลาดในการสมัครสมาชิก");
      }
    } catch (error) {
      console.error("Axios error:", error);

      // Handle errors from server
      if (error.response) {
        // Server responded with a status code outside 2xx
        toast.error(
          error.response.data?.message ||
            `Server error ${error.response.status}`
        );
      } else {
        // Other errors
        toast.error(`เกิดข้อผิดพลาด: ${error.message}`);
      }
    }
  };

  return (
    <Box
      sx={{
        width: "99vw",
        height: "97vh",
        display: "flex",
        backgroundColor: "#80BDB6",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      {/* Logo */}
      <Box sx={{ position: "absolute", top: 16, left: 16 }}>
        <img src={iconImg} alt="logo-top" style={{ width: 100, height: 100 }} />
      </Box>

      {/* Register Form */}
      <Paper
        elevation={4}
        sx={{
          padding: 3,
          width: "40%",
          maxHeight: "85vh",
          overflowY: "auto",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          borderRadius: "20px",
          backgroundColor: "#C8EAE6",
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          ลงทะเบียนเข้าใช้งาน (Register)
        </Typography>

        {/* Member Rank Dropdown */}
        <FormControl sx={{ width: "90%" }}>
          <InputLabel>ยศ</InputLabel>
          <Select
            name="member_rank"
            value={formData.member_rank}
            onChange={handleChange}
            label="ยศ"
            sx={{ textAlign: "left" }}
          >
            {RANKS.map((rank, idx) => (
              <MenuItem key={idx} value={rank}>
                {rank}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Input Fields */}
        {[
          { label: "ชื่อ", name: "member_name" },
          { label: "สกุล", name: "member_surname" },
          { label: "ตำแหน่ง", name: "member_position" },
          { label: "Username", name: "user_name" },
          { label: "Password", name: "password", type: "password" },
          {
            label: "Confirm Password",
            name: "confirm_password",
            type: "password",
          },
        ].map((field) => (
          <TextField
            key={field.name}
            variant="outlined"
            label={field.label}
            name={field.name}
            type={field.type || "text"}
            value={formData[field.name]}
            onChange={handleChange}
            error={Boolean(errors[field.name])}
            helperText={errors[field.name] || ""} // Show error under field
            sx={{
              width: "90%",
              "& .MuiOutlinedInput-root": {
                borderRadius: "20px",
                backgroundColor: "#fff",
              },
            }}
          />
        ))}

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            width: "60%",
          }}
        >
          <Button
            variant="contained"
            sx={{
              borderRadius: "20px",
              backgroundColor: "#368D83",
              color: "#fff",
              flex: 1,
              mr: 1,
            }}
            onClick={handleSubmit}
          >
            ลงทะเบียน
          </Button>
          <Button
            variant="outlined"
            sx={{
              borderRadius: "20px",
              borderColor: "#368D83",
              color: "#368D83",
              flex: 1,
              ml: 1,
              backgroundColor: "rgba(255, 255, 255, 0.6)",
                "&:hover": {
                  borderColor: "#286961",
                  color: "#286961",
                  backgroundColor: "rgba(54, 141, 131, 0.08)",
                },
            }}
            onClick={() => navigate("/login")}
          >
            ย้อนกลับ
          </Button>
        </Box>
      </Paper>

    </Box>
  );
};

export default Register;
